"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UseDetailDialog',
  data: function data() {
    return {
      visible: false,
      instanceCardId: '',
      detailData: {},
      recordList: [],
      recordLoading: false,
      recordTotal: 0,
      recordPage: 1,
      recordLimit: 8,
      stat: {
        total: 0,
        used: 0,
        waiting: 0
      }
    };
  },
  methods: {
    open: function open(instanceCardId) {
      this.visible = true;
      this.instanceCardId = instanceCardId;
      this.recordPage = 1;
      this.loadDetail();
    },
    handleClose: function handleClose() {
      this.recordPage = 1;
      this.instanceCardId = '';
      this.detailData = {};
      this.recordList = [];
      this.stat = {
        total: 0,
        used: 0,
        waiting: 0
      };
    },
    loadDetail: function loadDetail() {
      var _this = this;
      this.recordLoading = true;
      storeApi.cardInstanceUseDetail({
        id: this.instanceCardId,
        page: this.recordPage,
        limit: this.recordLimit
      }).then(function (res) {
        var data = res || {};
        var rightPage = data.rightPage || {};
        _this.detailData = data;
        _this.recordList = (rightPage.list || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            detailList: [],
            detailLoaded: false,
            detailLoading: false,
            detailPage: 1,
            detailLimit: 10,
            detailTotal: 0
          });
        });
        _this.recordTotal = rightPage.total || 0;
        var summary = data.summary || {};
        _this.stat = {
          total: summary.totalProductCount || 0,
          used: summary.usedCount || 0,
          waiting: summary.waitingCount || 0
        };
      }).catch(function () {
        _this.detailData = {};
        _this.recordList = [];
        _this.recordTotal = 0;
      }).finally(function () {
        _this.recordLoading = false;
      });
    },
    handleExpandChange: function handleExpandChange(row, expandedRows) {
      var expanded = expandedRows.some(function (item) {
        return item.rightConfigId === row.rightConfigId;
      });
      if (!expanded || row.detailLoaded || row.detailLoading) {
        return;
      }
      this.loadRightUseRecords(row);
    },
    loadRightUseRecords: function loadRightUseRecords(row) {
      var _this2 = this;
      this.$set(row, 'detailLoading', true);
      storeApi.cardRightUseRecord({
        instanceCardId: this.instanceCardId,
        rightConfigId: row.rightConfigId,
        page: row.detailPage,
        limit: row.detailLimit
      }).then(function (res) {
        var pageData = res || {};
        var list = pageData.list || [];
        _this2.$set(row, 'detailList', list.map(function (item, index) {
          return _objectSpread(_objectSpread({}, item), {}, {
            idx: (row.detailPage - 1) * row.detailLimit + index + 1
          });
        }));
        _this2.$set(row, 'detailTotal', pageData.total || 0);
        _this2.$set(row, 'detailLoaded', true);
      }).finally(function () {
        _this2.$set(row, 'detailLoading', false);
      });
    },
    handleDetailCurrentChange: function handleDetailCurrentChange(row, page) {
      this.$set(row, 'detailPage', page);
      this.$set(row, 'detailLoaded', false);
      this.loadRightUseRecords(row);
    },
    handleRecordCurrentChange: function handleRecordCurrentChange(val) {
      this.recordPage = val;
      this.loadDetail();
    },
    cardStatusTagType: function cardStatusTagType(val) {
      var map = {
        1: 'info',
        2: 'warning',
        3: '',
        4: 'success',
        5: 'info',
        6: 'danger'
      };
      return map[val] != null ? map[val] : 'info';
    }
  }
};